import { LayoutInitState } from "./types";

const initialState: LayoutInitState = {
  sideBarSubMenuOpen: false,
};

export { initialState };
